import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { BreadcrumbNav } from "@/components/breadcrumb-nav"
import { PageHeader } from "@/components/page-header"
import { ContractForm } from "@/features/contracts/components/contract-form"
import { useCreateContract } from "@/features/contracts/hooks/use-contract-mutations"
import { paths } from "@/routes/paths"

export function ContractNewPage() {
  const { t } = useTranslation("contracts")
  const navigate = useNavigate()
  const create = useCreateContract()

  return (
    <div className="flex flex-col gap-6">
      <BreadcrumbNav
        crumbs={[
          { label: t("title"), to: paths.contracts },
          { label: t("newContract") },
        ]}
      />
      <PageHeader title={t("newContract")} />
      <ContractForm
        isSubmitting={create.isPending}
        onSubmit={(payload) => {
          create.mutate(payload, {
            onSuccess: ({ id }) => {
              navigate(paths.contractDetail(id), { replace: true })
            },
          })
        }}
      />
    </div>
  )
}
